import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _title, _backgroundNotify;
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import Service, { service } from "@ember/service";
import { disableImplicitInjections } from "discourse/lib/implicit-injections";
import updateTabCount from "discourse/lib/update-tab-count";
import getURL from "discourse-common/lib/get-url";
let DocumentElement = disableImplicitInjections(_class = (_class2 = (_title = /*#__PURE__*/new WeakMap(), _backgroundNotify = /*#__PURE__*/new WeakMap(), class DocumentElement extends Service {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "appEvents", _descriptor, this);
    _initializerDefineProperty(this, "currentUser", _descriptor2, this);
    _initializerDefineProperty(this, "session", _descriptor3, this);
    _initializerDefineProperty(this, "siteSettings", _descriptor4, this);
    _defineProperty(this, "contextCount", 0);
    _defineProperty(this, "notificationCount", 0);
    _classPrivateFieldInitSpec(this, _title, null);
    _classPrivateFieldInitSpec(this, _backgroundNotify, null);
  }
  getTitle() {
    return _classPrivateFieldGet(_title, this);
  }
  setTitle(title) {
    _classPrivateFieldSet(_title, this, title);
    this._renderTitle();
  }
  setFocus(focus) {
    let {
      session
    } = this;
    session.hasFocus = focus;
    if (session.hasFocus && _classPrivateFieldGet(_backgroundNotify, this)) {
      this.updateContextCount(0);
    }
    _classPrivateFieldSet(_backgroundNotify, this, false);
    if (session.hasFocus) {
      this.notificationCount = 0;
    }
    this.appEvents.trigger("discourse:focus-changed", session.hasFocus);
    this._renderFavicon();
    this._renderTitle();
  }
  updateContextCount(count) {
    this.contextCount = count;
    this._renderTitle();
  }
  updateNotificationCount(count) {
    let {
      forced = false
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!this.session.hasFocus || forced) {
      this.notificationCount = count;
      this._renderFavicon();
      this._renderTitle();
    }
  }
  incrementBackgroundContextCount() {
    if (!this.session.hasFocus) {
      _classPrivateFieldSet(_backgroundNotify, this, true);
      this.contextCount += 1;
      this._renderFavicon();
      this._renderTitle();
    }
  }
  _displayCount() {
    return this.currentUser?.user_option.title_count_mode === "notifications" ? this.notificationCount : this.contextCount;
  }
  _renderTitle() {
    let title = _classPrivateFieldGet(_title, this) || this.siteSettings.title;
    let displayCount = this._displayCount();
    let dynamicFavicon = this.currentUser?.user_option.dynamic_favicon;
    if (this.currentUser?.isInDoNotDisturb()) {
      document.title = title;
      return;
    }
    if (displayCount > 0 && !dynamicFavicon) {
      title = `(${displayCount}) ${title}`;
    }
    document.title = title;
  }
  _renderFavicon() {
    if (this.currentUser?.user_option.dynamic_favicon) {
      let url = this.siteSettings.site_favicon_url;

      // Since the favicon is cached on the browser for a really long time, we
      // append the favicon_url as query params to the path so that the cache
      // is not used when the favicon changes.
      if (/^http/.test(url)) {
        url = getURL("/favicon/proxied?" + encodeURIComponent(url));
      }
      updateTabCount(url, this._displayCount());
    }
  }
}), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "appEvents", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "currentUser", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "siteSettings", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class;
export { DocumentElement as default };